import React from 'react';
import { motion } from 'framer-motion';
import { Activity } from 'lucide-react';
export function ProblemSection() {
  return <section className="w-full bg-midnight py-24 px-6" data-id="element-151">
      <div className="max-w-4xl mx-auto" data-id="element-152">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-153">
          <h2 className="font-display text-3xl md:text-5xl text-bone uppercase leading-tight mb-12 text-center" data-id="element-154">
            A los 40+, tu insomnio no es solo "falta de sueño".{' '}
            <br className="hidden md:block" data-id="element-155" />
            <span className="text-alert" data-id="element-156">
              Es un estado de hiper-vigilancia.
            </span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 items-center" data-id="element-157">
          <motion.div className="md:col-span-7 space-y-6 text-steel text-lg leading-relaxed" initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-158">
            <p data-id="element-159">
              Tu sistema nervioso cree que hay un incendio que apagar o un
              depredador acechando, y por eso te mantiene despierto.
            </p>
            <p data-id="element-160">
              El problema es que este agotamiento crónico está erosionando lo
              más valioso que tienes: tu capacidad de enfoque, tu paciencia con
              tu familia y tu autoridad en el trabajo. Estás operando al 40% de
              tu capacidad real y sabes que no puedes mantener este ritmo mucho
              más tiempo sin que algo se rompa.
            </p>
          </motion.div>

          <motion.div className="md:col-span-5 bg-midnight-deep p-8 border border-alert/20 flex flex-col items-center justify-center text-center" initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} data-id="element-161">
            <Activity className="w-12 h-12 text-alert mb-4" data-id="element-162" />
            <div className="font-display text-6xl text-alert mb-2" data-id="element-163">40%</div>
            <p className="text-bone font-bold uppercase tracking-wide text-sm" data-id="element-164">
              De tu capacidad real
            </p>
            <p className="text-steel text-sm mt-2" data-id="element-165">
              Estás operando con una batería crítica.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}